import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class DeckBuildingLive extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }

    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Deck Building is Live!</h1>

          <p style={size13}>
            By: Psynight - March 10, 2018
          </p>
          <img src={"../ArticleImages/deckofcards270x180.jpg"} style={imgCenterStyle} className="img-fluid" id="open" alt="open" />
          <p style={answerStyle}>
            Welcome to the newcomers, and returning readers!  This update I am very excited about, in reality it is the whole reason I built this site.  Deck builing is now live.
            I will be posting all of my decks, and I hope all of you will be doing the same.
          </p>
          <p style={answerStyle}>
            With this update I have added the following:
            <ul>
              <li> Deck Building </li>
              <li> Up Voting of Decks </li>
              <li> Favoriting Decks </li>
              <li> Favorite Decks table on the User Home page </li>
              <li> Deck Grid that list all the decks that have been added </li>
              <li> Deck View to see the details of the decks and the ability to comment on them.</li>
            </ul>
          </p>
          <p style={answerStyle}>
            The deck building feature is built around the idea that you can use it on mobile, tablet and desktop.  Building something like a deckbuilder for a mobile experience was challenging.
            If you run into issues or have suggestions for improvements please post in the comments or send me an email at psynight@novablitzhq.com
          </p>
          <p>
            The deck description field currently does not support formatting, adding a rich text editor will be one of my next big focuses.  So please add descriptions, but do not spend a lot of time trying to make it look pretty.
          </p>
          <p>
            To make the mobile experience better in the deck builder each of the 4 buttons are a toggle for that section, I find that as you are building the deck,
            hiding the filter section or the card gallery to quickly view your deck list is a handy feature.  One annoyance that I have found on mobile and tablet is if you click twice in a row to add multiple copies of a card it will zoom the page in.
            I will be working on a resolution to that issue, it drives me as crazy as I am sure it will drive you.  Another annoying issue that is on my to do list is comments do not immediately show up when posted.  Rest assured they did get saved.
          </p>
          <p style={answerStyle}>
            Some of the next big features I want to add to the site:
            <ul>
              <li> Featured decks on the front page </li>
              <li> Rich Text Editor for Deck Descriptions </li>
              <li> Refresh Comments so they display immediately upon posting</li>
              <li> Filters for the deck grid </li>
              <li> Ability to Delete decks </li>
              <li> Ability to edit and delete comments </li>
              <li> Logo update and background redesign </li>
            </ul>
          </p>
          <p style={answerStyle}>
            Let me know of about any other features that you would like to see on the site.  Thanks for reading, I am looking forward to seeing the decks everyone creates.
          </p>
          <h2 style={answerStyle}>Nova Token Platform News</h2>
          <p>
            In other exciting news Nova Tokens have been added to <a href="https://forkdelta.github.io/#!/trade/NVT-ETH">ForkDelta</a> and <a href="https://app.radarrelay.com/NVT/WETH">Radar Relay</a>.
            To read more about Nova Token and how it will tie into the Nova Blitz game make sure to check out <a href="https://www.novablitz.com">NovaBlitz.com</a> and read the white paper.
          </p>

        </div>
          <ArticleComments articleId={"3"} />
      </div>


    );
  }
}

export default DeckBuildingLive;



// WEBPACK FOOTER //
// ./src/Articles/DeckBuildingLive.js